import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'postalCode', 'address', 'neighborhood', 'complement', 'city', 'state'
  ]

  fill() {
    if (this.postalCodeTarget.value.length == 9) {
      $(".address-input-block").prop('disabled', true);
      $.get(`${this.data.get('url')}?postal_code=${this.postalCodeTarget.value}`, (data) => {
        if (data.response != 'not-found') {
          this.addressTarget.value = data.response.logradouro
          this.neighborhoodTarget.value = data.response.bairro
          this.cityTarget.value = data.response.localidade
          this.stateTarget.value = data.response.uf
        }
        $(".address-input-block").prop('disabled', false);
        $('#patient_address').focus();
      });
    }
  }
}
